import { useTranslation } from 'react-i18next';

import { useUpdatePostMutation } from '../hooks/usePostMutation';
import ModalConfirmation from '../../../../../shared/ModalConfirmation/ModalConfirmation.jsx';
import { Modal } from '../../../../boardSetup/components/Modals/Modal.jsx';
import { useNotification } from '../../../../../shared/Notification/useNotification';

export const DeleteReminderModal = ({
  open,
  setOpen,
  postId,
  campaignId,
  publishDate,
}) => {
  const { mutate } = useUpdatePostMutation();
  const { t } = useTranslation('reminders');
  const { showSuccess } = useNotification();

  const onSave = () => {
    mutate(
      { campaignId, reminderDate: null, id: postId, publishDate },
      {
        onSuccess: () => {
          showSuccess({ content: 'Reminder Deleted Successfully' });
        },
      },
    );
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalConfirmation
        variant="error"
        onSave={onSave}
        onCancel={() => setOpen(false)}
        header={t('deleteModal.title')}
        body={t('deleteModal.body')}
        cancelText={t('deleteModal.cancel')}
        submitText={t('deleteModal.delete')}
      />
    </Modal>
  );
};
